import { Typography } from '@mui/material';
import { Layout } from '../components/Layout';

export const TraitOverview = (props) => {
    return (
        <Layout title={props.title}>
            <Typography>{props.title}</Typography>
        </Layout>
    )
}